import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';
import { LocationService } from 'src/app/_services/location/location.service';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { LBSUtils } from 'src/app/_util/lbs-utils';
import { CarSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/car-select-remote-action-builder-ui-step/car-select-remote-action-builder-ui-step';
import { CarSelectRaStepComponent } from 'src/app/_components/remote-action-step/car-select-ra-step/car-select-ra-step.component';
import { DriverSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/driver-select-remote-action-builder-ui-step/driver-select-remote-action-builder-ui-step';
import { TeamRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/team-remote-action-builder-service-step/team-remote-action-builder-service-step';
import { ServicejobSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/servicejob-select-remote-action-builder-ui-step/servicejob-select-remote-action-builder-ui-step';
import { ServicejobSelectRaStepComponent } from 'src/app/_components/remote-action-step/servicejob-select-ra-step/servicejob-select-ra-step.component';
import { EventService } from 'src/app/_services/event/event.service';
import { ServicejobIdRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/servicejob-id-remote-action-builder-service-step/servicejob-id-remote-action-builder-service-step';
import { ServicejobsService } from 'src/app/_services/servicejobs/logic/servicejobs.service';
import { JobIdentificationRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/job-identification-remote-action-builder-ui-step/job-identification-remote-action-builder-ui-step';
import { JobIdentificationComponent } from 'src/app/_components/remote-action-step/job-identification/job-identification.component';

export class JobIdentificationRemoteActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    private clientStateService: ClientStateService,
    appService: AppService,
    credentialsService: CredentialsService,
    employeeService: EmployeeService,
    locationService: LocationService,
    serviceJobsService: ServicejobsService,
    private timeaccstartTs: string,
    private logger?: LoggingService,
  ) {
    super(
      'JOB-IDENTIFICATION-REMOTEACTION.PAGE-TITLE',
      appService,
      credentialsService,
      {
        endpoint: 'jobidentification',
        authenticationRequired: true,
        fifo: true,
        cachable: true,
        shortLabel: 'JOB-IDENTIFICATION-REMOTEACTION.RA.LABEL.SHORT',
        shortLabelTranslate: true,
        longLabel: serviceJobsService.getServiceJobById(clientStateService.theState.getValue()?.serviceJobId)?.displayLabel,
        longLabelTranslate: false,
        data: {},
      },
      []
        .concat([new JobIdentificationRemoteActionBuilderUiStep(logger)]),
      [
        new ServicejobIdRemoteActionBuilderServiceStep(clientStateService, serviceJobsService, logger),
        new TeamRemoteActionBuilderServiceStep(
          employeeService,
          clientStateService,
          logger
        ),
        new GpsRemoteActionBuilderServiceStep(locationService, logger),
      ],
      async (data: any) => {
        logger.log(
          this.constructor.name,
          ' Executing post generate function',
          data
        );

        if (data['curcarid']) {
          await this.clientStateService.setLastUsedCarId({
            imsId: data['curcarid'],
            secondaryId: undefined,
            objRef: 'ims/Car',
          });
        }
        if (data['dpflag']) {
          await this.clientStateService.setIsPassenger(data['dpflag'] == 'dpp');
        }
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    const ra: RemoteAction = await super.generateRemoteAction(dataValues);
    return ra;
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);

    // Configure specific Components
    if (componentRef.instance instanceof JobIdentificationComponent) {
      (<JobIdentificationComponent>componentRef.instance).setTimeAccStart(
        this.timeaccstartTs
      );
    }

    return componentRef;
  }
}
